import { initContract } from "@ts-rest/core";
import { createQuickbooksConnectionBodySchema } from "@common/schemas/quickbooks-connection.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { integrationConnectionWithAccountsResponseSchema } from "@common/schemas/domains/integrationConnection/integration-connection-response.schema";

const c = initContract();

export const quickbooksContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: createQuickbooksConnectionBodySchema,
            responses: {
                201: integrationConnectionWithAccountsResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/quickbooks",
    },
);
